import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const InfoModal = ({ show, onHide, title, body }) => {
  return (
    <Modal show={show} onHide={onHide} centered className="archon-branded-modal">
      <Modal.Header closeButton className="archon-branded-modal__header">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {body}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InfoModal;